import React, {useEffect, useRef, useState} from 'react';
import {Box, useTheme} from 'native-base';
import {
  PanelSeparator,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';

const MarTechContentContainer: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [hasContent, setHasContent] = useState(false);
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const {white} = theme.colors as any;

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (containerRef.current) {
        const hasInjectedContent =
          containerRef.current.innerHTML.trim().length > 0 ||
          containerRef.current.hasChildNodes();
        setHasContent(hasInjectedContent);
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Box
        ref={containerRef}
        width="100%"
        shadow={isDesktop ? 0 : undefined}
        backgroundColor={white}
        padding={hasContent ? (isDesktop ? 8 : 5) : 0}
        nativeID="marTechContainer"
      />
      {hasContent && <PanelSeparator />}
    </>
  );
};

export default MarTechContentContainer;
